import { CountUp } from 'countup.js';
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';

const attachContactSellerCTAListeners = () => {
    document.querySelectorAll('[data-contact-seller]').forEach((element) => {
        element.addEventListener('click', () => {
            const inputMessageDemo = document.getElementById('message');
            const sectionConversationCard = document.getElementById('conversation_card');

            sectionConversationCard.scrollIntoView({ block: 'center', behavior: 'smooth' });

            if (inputMessageDemo) {
                inputMessageDemo.focus({ preventScroll: true });

                return;
            }

            if (window?.app?.$refs?.conversationBox) {
                window.app.$refs.conversationBox.focusMessageField();
            }
        });
    });
};

const initCounterUp = () => {
    let element = document.getElementById('counter_up_intersection_trigger');
    if (element) {
        const intersectEventListener = (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const counterVisitors = new CountUp('counter_visitors', 4, {
                        startVal: 1,
                        duration: 3,
                        useEasing: false,
                    });
                    counterVisitors.start();

                    const counterTransactions = new CountUp('counter_transactions', 130000, {
                        duration: 3,
                    });
                    counterTransactions.start();

                    const counterFollowing = new CountUp('counter_following', 250000);
                    counterFollowing.start();

                    observer.unobserve(entry.target);
                }
            });
        };

        const observer = new IntersectionObserver(intersectEventListener, { threshold: 0.5 });
        const observable = document.getElementById('counter_up_intersection_trigger');

        observer.observe(observable);
    }
};

const initSwiper = () => {
    const swiperDisableBreakpoint = window.matchMedia('(min-width: 1024px)');
    let swiperInstance;

    const breakpointChangeEventListener = () => {
        if (swiperDisableBreakpoint.matches) {
            if (swiperInstance) {
                swiperInstance.destroy();
            }

            return;
        }

        enableSwiper();
    };

    const enableSwiper = () => {
        swiperInstance = new Swiper('.swiper', {
            modules: [Pagination],

            direction: 'horizontal',
            loop: false,

            slidesPerView: 1.7,
            centeredSlides: true,
            spaceBetween: 0,

            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    };

    swiperDisableBreakpoint.addEventListener('change', breakpointChangeEventListener);
    breakpointChangeEventListener();
};

attachContactSellerCTAListeners();
initCounterUp();

if (document.querySelectorAll('.swiper').length > 0) {
    initSwiper();
}
